export const carData = {
  hatchback: [
    {
      carName: "Maruti Suzuki Swift",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380132/swift__1_-removebg-preview_xyhxu3.png",
      rentalPrice: "80",
      model: "Swift",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.2 L K12M I4",
      power: "83 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Hyundai i20",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380128/hyundai__1_-removebg-preview_gfrnhq.png",
      rentalPrice: "90",
      model: "i20",
      mark: "Hyundai",
      year: "2024",
      engine: "1.2 L Kappa II I4",
      power: "83 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Altroz",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718382449/resize-1718382271990450654altroz1-removebg-preview_htvcgl.png",
      rentalPrice: "85",
      model: "Altroz",
      mark: "Tata",
      year: "2024",
      engine: "1.2 L Revotron I3",
      power: "86 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki Baleno",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380130/baleno__1_-removebg-preview_jutboc.png",
      rentalPrice: "90",
      model: "Baleno",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.2 L K12M I4",
      power: "83 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Hyundai Grand i10 Nios",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380133/nios__1_-removebg-preview_wbk8dq.png",
      rentalPrice: "80",
      model: "Grand i10 Nios",
      mark: "Hyundai",
      year: "2024",
      engine: "1.2 L Kappa II I4",
      power: "83 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Honda Jazz",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718382122/4ba4bsa_1460581-removebg-preview_sdu0ah.png",
      rentalPrice: "95",
      model: "Jazz",
      mark: "Honda",
      year: "2024",
      engine: "1.2 L i-VTEC I4",
      power: "90 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Volkswagen Polo",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380134/polo__1_-removebg-preview_w7bcxm.png",
      rentalPrice: "100",
      model: "Polo",
      mark: "Volkswagen",
      year: "2024",
      engine: "1.0 L TSI I3",
      power: "110 HP",
      maxSpeed: "190 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford Figo",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380127/ford-figo__1_-removebg-preview_uonei3.png",
      rentalPrice: "85",
      model: "Figo",
      mark: "Ford",
      year: "2024",
      engine: "1.2 L Ti-VCT I4",
      power: "96 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Renault Kwid",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380131/Kwid__1_-removebg-preview_g3vkwv.png",
      rentalPrice: "70",
      model: "Kwid",
      mark: "Renault",
      year: "2024",
      engine: "1.0 L BR10DE I3",
      power: "68 HP",
      maxSpeed: "150 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Tiago",
      carImage: "https://res.cloudinary.com/dxg1tfxsb/image/upload/v1718380134/tiago__1_-removebg-preview_llx0qu.png",
      rentalPrice: "80",
      model: "Tiago",
      mark: "Tata",
      year: "2024",
      engine: "1.2 L Revotron I3",
      power: "86 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
  ],
  sedan: [
    {
      carName: "Honda City",
      carImage: "{link}",
      rentalPrice: "120",
      model: "City",
      mark: "Honda",
      year: "2024",
      engine: "1.5 L i-VTEC I4",
      power: "121 HP",
      maxSpeed: "190 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki Dzire",
      carImage: "{link}",
      rentalPrice: "100",
      model: "Dzire",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.2 L K12M I4",
      power: "83 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Hyundai Verna",
      carImage: "{link}",
      rentalPrice: "130",
      model: "Verna",
      mark: "Hyundai",
      year: "2024",
      engine: "1.5 L MPI I4",
      power: "115 HP",
      maxSpeed: "185 km/h",
      gear: "Auto",
    },
    {
      carName: "Skoda Rapid",
      carImage: "{link}",
      rentalPrice: "140",
      model: "Rapid",
      mark: "Skoda",
      year: "2024",
      engine: "1.0 L TSI I3",
      power: "110 HP",
      maxSpeed: "185 km/h",
      gear: "Auto",
    },
    {
      carName: "Toyota Yaris",
      carImage: "{link}",
      rentalPrice: "125",
      model: "Yaris",
      mark: "Toyota",
      year: "2024",
      engine: "1.5 L Dual VVT-i I4",
      power: "107 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Volkswagen Vento",
      carImage: "{link}",
      rentalPrice: "130",
      model: "Vento",
      mark: "Volkswagen",
      year: "2024",
      engine: "1.0 L TSI I3",
      power: "110 HP",
      maxSpeed: "185 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Tigor",
      carImage: "{link}",
      rentalPrice: "100",
      model: "Tigor",
      mark: "Tata",
      year: "2024",
      engine: "1.2 L Revotron I3",
      power: "86 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Honda Amaze",
      carImage: "{link}",
      rentalPrice: "110",
      model: "Amaze",
      mark: "Honda",
      year: "2024",
      engine: "1.2 L i-VTEC I4",
      power: "90 HP",
      maxSpeed: "160 km/h",
      gear: "Auto",
    },
    {
      carName: "Hyundai Aura",
      carImage: "{link}",
      rentalPrice: "105",
      model: "Aura",
      mark: "Hyundai",
      year: "2024",
      engine: "1.2 L Kappa II I4",
      power: "83 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Skoda Slavia",
      carImage: "{link}",
      rentalPrice: "150",
      model: "Slavia",
      mark: "Skoda",
      year: "2024",
      engine: "1.0 L TSI I3",
      power: "115 HP",
      maxSpeed: "190 km/h",
      gear: "Auto",
    },
  ],
  suv: [
    {
      carName: "Hyundai Creta",
      carImage: "{link}",
      rentalPrice: "130",
      model: "Creta",
      mark: "Hyundai",
      year: "2024",
      engine: "1.5 L MPi I4",
      power: "115 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Kia Seltos",
      carImage: "{link}",
      rentalPrice: "135",
      model: "Seltos",
      mark: "Kia",
      year: "2024",
      engine: "1.5 L MPi I4",
      power: "115 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Nexon",
      carImage: "{link}",
      rentalPrice: "125",
      model: "Nexon",
      mark: "Tata",
      year: "2024",
      engine: "1.2 L Revotron I3",
      power: "120 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra XUV700",
      carImage: "{link}",
      rentalPrice: "200",
      model: "XUV700",
      mark: "Mahindra",
      year: "2024",
      engine: "2.0 L mStallion Turbo I4",
      power: "200 HP",
      maxSpeed: "200 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki Vitara Brezza",
      carImage: "{link}",
      rentalPrice: "120",
      model: "Vitara Brezza",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.5 L K15B I4",
      power: "105 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Toyota Fortuner",
      carImage: "{link}",
      rentalPrice: "250",
      model: "Fortuner",
      mark: "Toyota",
      year: "2024",
      engine: "2.8 L GD I4",
      power: "201 HP",
      maxSpeed: "176 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford EcoSport",
      carImage: "{link}",
      rentalPrice: "110",
      model: "EcoSport",
      mark: "Ford",
      year: "2024",
      engine: "1.5 L Ti-VCT I4",
      power: "122 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "MG Hector",
      carImage: "{link}",
      rentalPrice: "140",
      model: "Hector",
      mark: "MG",
      year: "2024",
      engine: "1.5 L Turbo I4",
      power: "143 HP",
      maxSpeed: "190 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra Thar",
      carImage: "{link}",
      rentalPrice: "160",
      model: "Thar",
      mark: "Mahindra",
      year: "2024",
      engine: "2.0 L mStallion Turbo I4",
      power: "150 HP",
      maxSpeed: "155 km/h",
      gear: "Auto",
    },
    {
      carName: "Renault Duster",
      carImage: "{link}",
      rentalPrice: "120",
      model: "Duster",
      mark: "Renault",
      year: "2024",
      engine: "1.3 L Turbo I4",
      power: "156 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
  ],
  mpv: [
    {
      carName: "Toyota Innova Crysta",
      carImage: "{link}",
      rentalPrice: "150",
      model: "Innova Crysta",
      mark: "Toyota",
      year: "2024",
      engine: "2.4 L GD I4",
      power: "150 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki Ertiga",
      carImage: "{link}",
      rentalPrice: "120",
      model: "Ertiga",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.5 L K15B I4",
      power: "103 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra Marazzo",
      carImage: "{link}",
      rentalPrice: "130",
      model: "Marazzo",
      mark: "Mahindra",
      year: "2024",
      engine: "1.5 L D15 I4",
      power: "121 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
    {
      carName: "Renault Triber",
      carImage: "{link}",
      rentalPrice: "100",
      model: "Triber",
      mark: "Renault",
      year: "2024",
      engine: "1.0 L BR10DE I3",
      power: "72 HP",
      maxSpeed: "160 km/h",
      gear: "Auto",
    },
    {
      carName: "Kia Carens",
      carImage: "{link}",
      rentalPrice: "140",
      model: "Carens",
      mark: "Kia",
      year: "2024",
      engine: "1.5 L Smartstream I4",
      power: "115 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra Xylo",
      carImage: "{link}",
      rentalPrice: "125",
      model: "Xylo",
      mark: "Mahindra",
      year: "2024",
      engine: "2.5 L mDI CRDe I4",
      power: "95 HP",
      maxSpeed: "155 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki XL6",
      carImage: "{link}",
      rentalPrice: "130",
      model: "XL6",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.5 L K15B I4",
      power: "103 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Honda BR-V",
      carImage: "{link}",
      rentalPrice: "140",
      model: "BR-V",
      mark: "Honda",
      year: "2024",
      engine: "1.5 L i-VTEC I4",
      power: "119 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Datsun GO+",
      carImage: "{link}",
      rentalPrice: "110",
      model: "GO+",
      mark: "Datsun",
      year: "2024",
      engine: "1.2 L I3",
      power: "68 HP",
      maxSpeed: "150 km/h",
      gear: "Auto",
    },
    {
      carName: "Toyota Vellfire",
      carImage: "{link}",
      rentalPrice: "200",
      model: "Vellfire",
      mark: "Toyota",
      year: "2024",
      engine: "2.5 L 2AR-FE I4",
      power: "150 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
  ],
  ev: [
    {
      carName: "Tata Nexon EV",
      carImage: "./image/nexon_ev.jpg",
      rentalPrice: "110",
      model: "Nexon EV",
      mark: "Tata",
      year: "2024",
      engine: "Electric",
      power: "129 HP",
      maxSpeed: "120 km/h",
      gear: "Auto",
    },
    {
      carName: "MG ZS EV",
      carImage: "./image/zs_ev.jpg",
      rentalPrice: "120",
      model: "ZS EV",
      mark: "MG",
      year: "2024",
      engine: "Electric",
      power: "141 HP",
      maxSpeed: "140 km/h",
      gear: "Auto",
    },
    {
      carName: "Hyundai Kona Electric",
      carImage: "./image/kona.jpg",
      rentalPrice: "130",
      model: "Kona Electric",
      mark: "Hyundai",
      year: "2024",
      engine: "Electric",
      power: "134 HP",
      maxSpeed: "155 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Tigor EV",
      carImage: "./image/tigor_ev.jpg",
      rentalPrice: "100",
      model: "Tigor EV",
      mark: "Tata",
      year: "2024",
      engine: "Electric",
      power: "74 HP",
      maxSpeed: "123 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra eVerito",
      carImage: "./image/everito.jpg",
      rentalPrice: "90",
      model: "eVerito",
      mark: "Mahindra",
      year: "2024",
      engine: "Electric",
      power: "41 HP",
      maxSpeed: "86 km/h",
      gear: "Auto",
    },
    {
      carName: "BYD e6",
      carImage: "./image/e6.jpg",
      rentalPrice: "95",
      model: "e6",
      mark: "BYD",
      year: "2024",
      engine: "Electric",
      power: "121 HP",
      maxSpeed: "130 km/h",
      gear: "Auto",
    },
    {
      carName: "Jaguar I-PACE",
      carImage: "./image/ipace.jpg",
      rentalPrice: "500",
      model: "I-PACE",
      mark: "Jaguar",
      year: "2024",
      engine: "Electric",
      power: "394 HP",
      maxSpeed: "200 km/h",
      gear: "Auto",
    },
    {
      carName: "Audi e-tron",
      carImage: "./image/etron.jpg",
      rentalPrice: "550",
      model: "e-tron",
      mark: "Audi",
      year: "2024",
      engine: "Electric",
      power: "402 HP",
      maxSpeed: "200 km/h",
      gear: "Auto",
    },
    {
      carName: "Mercedes-Benz EQC",
      carImage: "./image/eqc.jpg",
      rentalPrice: "600",
      model: "EQC",
      mark: "Mercedes-Benz",
      year: "2024",
      engine: "Electric",
      power: "402 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Nissan Leaf",
      carImage: "./image/leaf.jpg",
      rentalPrice: "120",
      model: "Leaf",
      mark: "Nissan",
      year: "2024",
      engine: "Electric",
      power: "147 HP",
      maxSpeed: "144 km/h",
      gear: "Auto",
    },
  ],
  luxury: [
    {
      carName: "Mercedes-Benz S-Class",
      carImage: "{link}",
      rentalPrice: "1500",
      model: "S-Class",
      mark: "Mercedes-Benz",
      year: "2024",
      engine: "3.0 L I6 / 4.0 L V8 / 6.0 L V12",
      power: "Up to 621 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "BMW 7 Series",
      carImage: "{link}",
      rentalPrice: "1400",
      model: "7 Series",
      mark: "BMW",
      year: "2024",
      engine: "3.0 L I6 / 4.4 L V8",
      power: "Up to 601 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Audi A8",
      carImage: "{link}",
      rentalPrice: "1350",
      model: "A8",
      mark: "Audi",
      year: "2024",
      engine: "3.0 L V6 / 4.0 L V8",
      power: "Up to 563 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Jaguar XJ",
      carImage: "{link}",
      rentalPrice: "1300",
      model: "XJ",
      mark: "Jaguar",
      year: "2024",
      engine: "3.0 L V6 / 5.0 L V8",
      power: "Up to 575 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Lexus LS",
      carImage: "{link}",
      rentalPrice: "1400",
      model: "LS",
      mark: "Lexus",
      year: "2024",
      engine: "3.5 L V6 / 4.6 L V8 / 5.0 L V8",
      power: "Up to 416 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Volvo S90",
      carImage: "{link}",
      rentalPrice: "1200",
      model: "S90",
      mark: "Volvo",
      year: "2024",
      engine: "2.0 L I4 / 2.0 L I4 Plug-in hybrid",
      power: "Up to 405 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Porsche Panamera",
      carImage: "{link}",
      rentalPrice: "1600",
      model: "Panamera",
      mark: "Porsche",
      year: "2024",
      engine: "2.9 L V6 / 4.0 L V8 / 4.0 L V8 hybrid / 4.0 L V8 plug-in hybrid",
      power: "Up to 690 HP",
      maxSpeed: "310 km/h",
      gear: "Auto",
    },
    {
      carName: "Bentley Continental GT",
      carImage: "{link}",
      rentalPrice: "2500",
      model: "Continental GT",
      mark: "Bentley",
      year: "2024",
      engine: "4.0 L V8 / 6.0 L W12",
      power: "Up to 626 HP",
      maxSpeed: "333 km/h",
      gear: "Auto",
    },
    {
      carName: "Rolls-Royce Ghost",
      carImage: "{link}",
      rentalPrice: "3000",
      model: "Ghost",
      mark: "Rolls-Royce",
      year: "2024",
      engine: "6.7 L V12",
      power: "563 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Maserati Quattroporte",
      carImage: "{link}",
      rentalPrice: "2000",
      model: "Quattroporte",
      mark: "Maserati",
      year: "2024",
      engine: "3.0 L V6 / 3.8 L V8",
      power: "Up to 580 HP",
      maxSpeed: "310 km/h",
      gear: "Auto",
    },
  ],
  sports: [
    {
      carName: "Porsche 911",
      carImage: "{link}",
      rentalPrice: "400",
      model: "911",
      mark: "Porsche",
      year: "2024",
      engine: "3.0 L Twin-Turbo Flat-6",
      power: "379 HP",
      maxSpeed: "308 km/h",
      gear: "Auto",
    },
    {
      carName: "Chevrolet Corvette",
      carImage: "{link}",
      rentalPrice: "350",
      model: "Corvette",
      mark: "Chevrolet",
      year: "2024",
      engine: "6.2 L LT2 V8",
      power: "490 HP",
      maxSpeed: "312 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford Mustang",
      carImage: "{link}",
      rentalPrice: "300",
      model: "Mustang",
      mark: "Ford",
      year: "2024",
      engine: "5.0 L Coyote V8",
      power: "450 HP",
      maxSpeed: "249 km/h",
      gear: "Auto",
    },
    {
      carName: "Audi R8",
      carImage: "{link}",
      rentalPrice: "450",
      model: "R8",
      mark: "Audi",
      year: "2024",
      engine: "5.2 L FSI V10",
      power: "562 HP",
      maxSpeed: "331 km/h",
      gear: "Auto",
    },
    {
      carName: "Nissan GT-R",
      carImage: "{link}",
      rentalPrice: "500",
      model: "GT-R",
      mark: "Nissan",
      year: "2024",
      engine: "3.8 L Twin-Turbo V6",
      power: "565 HP",
      maxSpeed: "315 km/h",
      gear: "Auto",
    },
    {
      carName: "BMW M4",
      carImage: "{link}",
      rentalPrice: "400",
      model: "M4",
      mark: "BMW",
      year: "2024",
      engine: "3.0 L Twin-Turbo I6",
      power: "473 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Ferrari 488",
      carImage: "{link}",
      rentalPrice: "600",
      model: "488",
      mark: "Ferrari",
      year: "2024",
      engine: "3.9 L Twin-Turbo V8",
      power: "661 HP",
      maxSpeed: "330 km/h",
      gear: "Auto",
    },
    {
      carName: "Lamborghini Huracan",
      carImage: "{link}",
      rentalPrice: "700",
      model: "Huracan",
      mark: "Lamborghini",
      year: "2024",
      engine: "5.2 L V10",
      power: "631 HP",
      maxSpeed: "325 km/h",
      gear: "Auto",
    },
    {
      carName: "Aston Martin Vantage",
      carImage: "{link}",
      rentalPrice: "550",
      model: "Vantage",
      mark: "Aston Martin",
      year: "2024",
      engine: "4.0 L Twin-Turbo V8",
      power: "503 HP",
      maxSpeed: "315 km/h",
      gear: "Auto",
    },
    {
      carName: "McLaren 720S",
      carImage: "{link}",
      rentalPrice: "800",
      model: "720S",
      mark: "McLaren",
      year: "2024",
      engine: "4.0 L Twin-Turbo V8",
      power: "710 HP",
      maxSpeed: "341 km/h",
      gear: "Auto",
    },
  ],
  crossover: [
    {
      carName: "Hyundai Venue",
      carImage: "{link}",
      rentalPrice: "110",
      model: "Venue",
      mark: "Hyundai",
      year: "2024",
      engine: "1.2 L Kappa I4",
      power: "83 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Kia Sonet",
      carImage: "{link}",
      rentalPrice: "115",
      model: "Sonet",
      mark: "Kia",
      year: "2024",
      engine: "1.2 L Kappa I4",
      power: "83 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Nissan Kicks",
      carImage: "{link}",
      rentalPrice: "120",
      model: "Kicks",
      mark: "Nissan",
      year: "2024",
      engine: "1.5 L HR15DE I4",
      power: "106 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Maruti Suzuki S-Cross",
      carImage: "{link}",
      rentalPrice: "125",
      model: "S-Cross",
      mark: "Maruti Suzuki",
      year: "2024",
      engine: "1.5 L K15B I4",
      power: "103 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Renault Kiger",
      carImage: "{link}",
      rentalPrice: "115",
      model: "Kiger",
      mark: "Renault",
      year: "2024",
      engine: "1.0 L HRA0 I3",
      power: "71 HP",
      maxSpeed: "150 km/h",
      gear: "Auto",
    },
    {
      carName: "Honda WR-V",
      carImage: "{link}",
      rentalPrice: "120",
      model: "WR-V",
      mark: "Honda",
      year: "2024",
      engine: "1.2 L i-VTEC I4",
      power: "90 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Toyota Urban Cruiser",
      carImage: "{link}",
      rentalPrice: "130",
      model: "Urban Cruiser",
      mark: "Toyota",
      year: "2024",
      engine: "1.5 L K15B I4",
      power: "103 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford Freestyle",
      carImage: "{link}",
      rentalPrice: "115",
      model: "Freestyle",
      mark: "Ford",
      year: "2024",
      engine: "1.2 L Ti-VCT I4",
      power: "95 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "MG Astor",
      carImage: "{link}",
      rentalPrice: "135",
      model: "Astor",
      mark: "MG",
      year: "2024",
      engine: "1.5 L VTi-Tech I4",
      power: "108 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Tata Punch",
      carImage: "{link}",
      rentalPrice: "140",
      model: "Punch",
      mark: "Tata",
      year: "2024",
      engine: "1.2 L Revotron I3",
      power: "86 HP",
      maxSpeed: "165 km/h",
      gear: "Auto",
    },
  ],
  pickup: [
    {
      carName: "Toyota Hilux",
      carImage: "{link}",
      rentalPrice: "150",
      model: "Hilux",
      mark: "Toyota",
      year: "2024",
      engine: "2.8 L 1GD-FTV I4",
      power: "201 HP",
      maxSpeed: "170 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford Ranger",
      carImage: "{link}",
      rentalPrice: "140",
      model: "Ranger",
      mark: "Ford",
      year: "2024",
      engine: "2.0 L EcoBlue I4",
      power: "168 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Isuzu D-Max V-Cross",
      carImage: "{link}",
      rentalPrice: "130",
      model: "D-Max V-Cross",
      mark: "Isuzu",
      year: "2024",
      engine: "1.9 L RZ4E I4",
      power: "150 HP",
      maxSpeed: "175 km/h",
      gear: "Auto",
    },
    {
      carName: "Mahindra Bolero Camper",
      carImage: "{link}",
      rentalPrice: "120",
      model: "Bolero Camper",
      mark: "Mahindra",
      year: "2024",
      engine: "1.5 L mHawk75 I4",
      power: "75 HP",
      maxSpeed: "120 km/h",
      gear: "Manual",
    },
    {
      carName: "Tata Yodha Pickup",
      carImage: "{link}",
      rentalPrice: "125",
      model: "Yodha Pickup",
      mark: "Tata",
      year: "2024",
      engine: "2.0 L VARICOR I4",
      power: "75 HP",
      maxSpeed: "120 km/h",
      gear: "Manual",
    },
    {
      carName: "Jeep Gladiator",
      carImage: "{link}",
      rentalPrice: "160",
      model: "Gladiator",
      mark: "Jeep",
      year: "2024",
      engine: "3.6 L Pentastar V6",
      power: "285 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Nissan Navara",
      carImage: "{link}",
      rentalPrice: "135",
      model: "Navara",
      mark: "Nissan",
      year: "2024",
      engine: "2.3 L YS23DDTT I4",
      power: "190 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "Mitsubishi L200",
      carImage: "{link}",
      rentalPrice: "130",
      model: "L200",
      mark: "Mitsubishi",
      year: "2024",
      engine: "2.2 L 4N14 I4",
      power: "148 HP",
      maxSpeed: "175 km/h",
      gear: "Manual",
    },
    {
      carName: "Chevrolet Colorado",
      carImage: "{link}",
      rentalPrice: "145",
      model: "Colorado",
      mark: "Chevrolet",
      year: "2024",
      engine: "2.5 L LCV I4",
      power: "200 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
    {
      carName: "GMC Sierra",
      carImage: "{link}",
      rentalPrice: "155",
      model: "Sierra",
      mark: "GMC",
      year: "2024",
      engine: "5.3 L L83 V8",
      power: "355 HP",
      maxSpeed: "180 km/h",
      gear: "Auto",
    },
  ],
  convertible: [
    {
      carName: "Mazda MX-5 Miata",
      carImage: "{link}",
      rentalPrice: "120",
      model: "MX-5 Miata",
      mark: "Mazda",
      year: "2024",
      engine: "2.0 L Skyactiv-G I4",
      power: "181 HP",
      maxSpeed: "220 km/h",
      gear: "Auto",
    },
    {
      carName: "BMW Z4",
      carImage: "{link}",
      rentalPrice: "150",
      model: "Z4",
      mark: "BMW",
      year: "2024",
      engine: "2.0 L BMW B48 I4",
      power: "255 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Porsche Boxster",
      carImage: "{link}",
      rentalPrice: "200",
      model: "Boxster",
      mark: "Porsche",
      year: "2024",
      engine: "2.0 L Turbocharged Flat-4",
      power: "300 HP",
      maxSpeed: "275 km/h",
      gear: "Auto",
    },
    {
      carName: "Audi A5 Cabriolet",
      carImage: "{link}",
      rentalPrice: "180",
      model: "A5 Cabriolet",
      mark: "Audi",
      year: "2024",
      engine: "2.0 L TFSI I4",
      power: "261 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Mercedes-Benz C-Class Cabriolet",
      carImage: "{link}",
      rentalPrice: "190",
      model: "C-Class Cabriolet",
      mark: "Mercedes-Benz",
      year: "2024",
      engine: "2.0 L Turbocharged I4",
      power: "255 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Jaguar F-Type Convertible",
      carImage: "{link}",
      rentalPrice: "220",
      model: "F-Type Convertible",
      mark: "Jaguar",
      year: "2024",
      engine: "2.0 L Turbocharged I4",
      power: "296 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Chevrolet Camaro Convertible",
      carImage: "{link}",
      rentalPrice: "200",
      model: "Camaro Convertible",
      mark: "Chevrolet",
      year: "2024",
      engine: "2.0 L Turbocharged I4",
      power: "275 HP",
      maxSpeed: "240 km/h",
      gear: "Auto",
    },
    {
      carName: "Ford Mustang Convertible",
      carImage: "{link}",
      rentalPrice: "210",
      model: "Mustang Convertible",
      mark: "Ford",
      year: "2024",
      engine: "2.3 L EcoBoost I4",
      power: "310 HP",
      maxSpeed: "250 km/h",
      gear: "Auto",
    },
    {
      carName: "Ferrari Portofino",
      carImage: "{link}",
      rentalPrice: "1000",
      model: "Portofino",
      mark: "Ferrari",
      year: "2024",
      engine: "3.9 L Twin-Turbocharged V8",
      power: "612 HP",
      maxSpeed: "320 km/h",
      gear: "Auto",
    },
    {
      carName: "Lexus LC Convertible",
      carImage: "{link}",
      rentalPrice: "300",
      model: "LC Convertible",
      mark: "Lexus",
      year: "2024",
      engine: "5.0 L V8",
      power: "471 HP",
      maxSpeed: "270 km/h",
      gear: "Auto",
    },
  ],
};
